import { render, staticRenderFns } from "./detailsa.vue?vue&type=template&id=cfdbc054&scoped=true&"
import script from "./detailsa.vue?vue&type=script&lang=js&"
export * from "./detailsa.vue?vue&type=script&lang=js&"
import style0 from "./detailsa.vue?vue&type=style&index=0&id=cfdbc054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdbc054",
  null
  
)

export default component.exports